export default __webpack_public_path__ + "static/media/scroll-down-arrow.8ad25c53.svg";